import { Dispatch, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { OrganizationTab, OrganizationTabs } from './tabs';
import styles from './index.module.scss';
import {
  IApiAdminRbacRole,
  ISupportUserModel,
  IUserListItem,
} from '../../../model/api-modules';
import { AdminRole } from './role';
import { AdminMembers } from './members';
import { useHistory, useLocation } from 'react-router';
import { getSupportRoleList, getSupportUsers } from '../../../api/admin/rbac';
import { getUserIdList } from '../../../api';

export const OrganizationManage = () => {
  const history = useHistory();
  const location = useLocation();
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  const [loading, setLoading] = useState<boolean>(false);
  const [tabKey, setTabKey] = useState<OrganizationTab>(
    OrganizationTab.Members
  );

  const [rolesList, setRolesList] = useState<ReadonlyArray<IApiAdminRbacRole>>(
    []
  );
  const [allUsers, setAllUsers] = useState<ReadonlyArray<IUserListItem>>([]);
  const [members, setMembers] = useState<ReadonlyArray<ISupportUserModel>>([]);

  useEffect(() => {
    menuDispatch({
      type: ReduxCommonActionType.SELECT_MENU_ID,
      result: SystemMenuId.SupportAccess,
    });
  }, []);

  useEffect(() => {
    init();
  }, [location]);

  const init = async (withLoading = false) => {
    if (location.pathname.includes('/organization-manage/members')) {
      setTabKey(OrganizationTab.Members);
    }
    if (location.pathname.includes('/organization-manage/roles')) {
      setTabKey(OrganizationTab.Roles);
    }
    setLoading(withLoading);
    const [roles, allUserRes, supportMembers] = await Promise.all([
      getSupportRoleList(),
      getUserIdList(),
      getSupportUsers(),
    ]);
    setLoading(false);
    if (!roles || !supportMembers) {
      return;
    }
    setRolesList(roles);
    setAllUsers(allUserRes);
    setMembers(supportMembers);
  };

  const onTabKeyChange = (key: OrganizationTab) => {
    history.push(`/admin/organization-manage/${key.toLocaleLowerCase()}`);
  };

  const renderContent = () => {
    if (tabKey === OrganizationTab.Roles) {
      return (
        <AdminRole
          loading={loading}
          allUser={allUsers}
          roles={rolesList}
          members={members}
          onChange={init}
        />
      );
    }
    if (tabKey === OrganizationTab.Members) {
      return (
        <AdminMembers
          loading={loading}
          allUser={allUsers}
          roles={rolesList}
          members={members}
          onChange={init}
        />
      );
    }
    return null;
  };

  const membersLength = members.length;

  // 页面上暂无内容
  return (
    <div className={styles.organizationContent}>
      <div className={styles.head}>
        <OrganizationTabs
          className={styles.organizationTabs}
          tabKey={tabKey}
          onChange={onTabKeyChange}
          membersLength={membersLength}
          rolesLength={rolesList.length}
        />
      </div>
      {renderContent()}
    </div>
  );
};
